import { Modal } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "../utils/manage.css";
import html2pdf from "html2pdf.js";

const DetailManageMoney = ({ isOpen, toggle, selectedBusiness }) => {
  if (!selectedBusiness) return null;
  const {
    status,
    createdAt,
    paymentMethodName,
    clientNumber,
    prefixPhone,
    amount,
    realAmount,
    currency,
    merchantAccountName,
    developerAccountName,
    transactionReference,
    merchant,
    account,
    transactionReferenceBank,
    
    // fallback BANK
    maskedBicCode,
    maskedIban,
    developerAccountName: businessBank,
    realAmount: bankAmount,
  } = selectedBusiness;
  const isBank = selectedBusiness?.type === "BANK";
const isMobile = selectedBusiness?.type === "MOBILE";
 const businessName = isMobile
  ? `${selectedBusiness?.developerAccountName || ""}`
  : selectedBusiness?.business || selectedBusiness?.business || "-";
 const beneficiary = isMobile
  ? `${selectedBusiness?.merchantAccountName || ""}`
  : selectedBusiness?.merchant || selectedBusiness?.merchant || "-";
const phone = isMobile
  ? `${selectedBusiness?.prefixPhone || ""} ${selectedBusiness?.clientNumber || "-"}`
  : selectedBusiness?.maskedIban || selectedBusiness?.client || "-";

const transaction = isMobile
  ? selectedBusiness?.transactionReference
  : selectedBusiness?.transactionReferenceBank || "-"; 

  const paymentMethod = isMobile
  ? selectedBusiness?.paymentMethodName
  : selectedBusiness?.account || "-";

const finalAmount = isMobile
  ? selectedBusiness?.amount
  : selectedBusiness?.amount;

const receivedAmount = selectedBusiness?.realAmount || selectedBusiness?.amount;
const formatDate = (date) => dayjs(date).format("DD-MM-YYYY");
  const handleDownload = () => {
    const element = document.getElementById("payment-detail-content");

    html2pdf()
      .from(element)
      .set({
        margin: 0.5,
        filename: `transaction_${transactionReference || "detail"}.pdf`,
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      })
      .save();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={toggle}
      footer={null}
      centered
       width="90%"
      style={{ maxWidth: 520 }}
      className="modal-detail-payment"
    >
      <div id="payment-detail-content" className="payment-container">

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2 className="modal-title">Information de la transaction</h2>

          <DownloadOutlined
            style={{ cursor: "pointer", fontSize: 18 }}
            onClick={handleDownload}
          />
        </div>

        <div className="payment-details">

          <div className="payment-row">
            <span className="label">Bénéficiaire</span>
            <span className="value">{beneficiary}</span>
          </div>

          <div className="payment-row">
            <span className="label">Business</span>
            <span className="value">{businessName}</span>
          </div>

          <div className="payment-row">
            <span className="label">Téléphone / Compte</span>
            <span className="value">{phone}</span>
          </div>

          <div className="payment-row">
            <span className="label">Date</span>
            <span className="value">{formatDate(createdAt)}</span>
          </div>

          <div className="payment-row">
            <span className="label">Montant débité</span>
            <span className="value">
              {Number(finalAmount).toLocaleString()} {currency || "XOF"}
            </span>
          </div>

          <div className="payment-row">
            <span className="label">Montant reçu</span>
            <span className="value">
              {Number(receivedAmount).toLocaleString()} {currency || "XOF"}
            </span>
          </div>

          <div className="payment-row">
            <span className="label">Moyen de paiement</span>
            <span className="value">{paymentMethod}</span>
          </div>

          {status && (
            <div className="payment-row">
              <span className="label">Statut</span>
              <span
                className="value"
                style={{
                  color:
                    status === "SUCCESS"
                      ? "#28a745"
                      : status === "PENDING"
                      ? "#f0ad4e"
                      : "#dc3545",
                  fontWeight: 500,
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
              >
                {status === "SUCCESS"
                  ? "Réussie"
                  : status === "PENDING"
                  ? "En attente"
                  : "Échec"}
              </span>
            </div>
          )}

          {transaction && (
            <div className="payment-row">
              <span className="label">Référence</span>
              <span className="value">{transaction}</span>
            </div>
          )}

        </div>
      </div>
    </Modal>
  );
};

export default DetailManageMoney;